import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";

/**
 * Confirmation modal for removing an event (replaces window.confirm).
 */
export default function EndStreamingModal({
  open,
  busy = false,
}) {

  const onClose = () => {
    window.location.href = "/my-events";
  }
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[70]"
        onClose={() => {
          if (!busy) onClose();
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60" aria-hidden />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95 translate-y-1"
              enterTo="opacity-100 scale-100 translate-y-0"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100 translate-y-0"
              leaveTo="opacity-0 scale-95 translate-y-1"
            >
              <Dialog.Panel className="w-full max-w-sm rounded-[20px] border border-[#6A6680] bg-[#230046] shadow-2xl">
                <div className="p-4 sm:p-6">
                  <div className="flex items-start justify-end">
                    <button
                      type="button"
                      className="rounded-md p-1 text-white/70 transition-colors hover:bg-white/10 hover:text-white !bg-transparent"
                      onClick={onClose}
                      aria-label="Close"
                    >
                      <XMarkIcon className="h-7 w-7" />
                    </button>
                  </div>

                  <Dialog.Title className="-mt-2 text-center text-[22px] font-bold text-white atkinson-font">
                    Session Timed Out
                  </Dialog.Title>

                  <p className="mt-3 text-center text-[0.95rem] leading-snug text-white/85 atkinson-font">
                    
                        This session has ended due to 30 minutes of inactivity.
                   
                  </p>

                  <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                    <button
                      type="button"
                      className="w-full rounded-lg border-2 border-red-800/60 !bg-red-600 py-2.5 text-base font-semibold !text-white shadow-none transition-colors hover:!bg-red-500 disabled:opacity-60 sm:w-auto sm:min-w-[120px] atkinson-font"
                      onClick={onClose}
                      disabled={busy}
                    >
                      Back to Events
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
